export default {
    getShows(state) {
        return state.shows;
    }

}